import { apiClient } from '../apiClient';
import { CreateOrderDto, InstalledOrderDto, Order, OrderQuery, UpdateOrderDto } from './types';

export async function getOrders(query: OrderQuery = {}) {
  return await apiClient.get<Order[]>('api/orders', {
    params: query,
  });
}

export async function getOrder(id: number) {
  return await apiClient.get<Order>(`api/orders/${id}`);
}

export async function getAssignedOrders() {
  return await apiClient.get<Order[]>('api/orders/assigned');
}

export async function createOrder(createOrderDto: CreateOrderDto) {
  return await apiClient.post<Order>('api/orders', createOrderDto);
}

export async function installedOrder(id: number, installedOrderDto: InstalledOrderDto) {
  return await apiClient.post<Order>(`api/orders/${id}/installed`, installedOrderDto);
}

export async function updateOrder(id: number, updateOrderDto: UpdateOrderDto) {
  return await apiClient.patch<Order>(`api/orders/${id}`, updateOrderDto);
}

export async function deleteOrder(id: number) {
  return await apiClient.delete<void>(`api/orders/${id}`);
}
